

export const iniciarChatWass = ({mensaje='Hola Quesuditas', numero=''}) =>{
    let texto = encodeURI(mensaje)
    let link = `https://api.whatsapp.com/send?phone=57${numero}&text=${texto}`
    window.open(link)
}